export const formatVersion = (version: { number: number } | null) =>
	version ? `опубликована v${version.number}` : "не опубликован"
